import {
  createFrontendPlugin,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { rootRouteRef } from './routes';

const secretsPage = PageBlueprint.make({
  name: 'secrets',
  params: {
    path: '/secrets',
    routeRef: convertLegacyRouteRef(rootRouteRef),
    loader: () =>
      import('./components/Secrets').then(m => <m.SecretsTable />),
  },
});

export const ciandtspikeSecretsPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'ciandtspike-frontend-multicloud-secrets',
  extensions: [secretsPage],
  routes: {
    root: convertLegacyRouteRef(rootRouteRef),
  },
});

// Re-export para uso no EntityPage enquanto ele estiver no compat bridge (S2.1)
export { SecretsTable as CiandtspikeSecretsPage } from './components/Secrets';

export default ciandtspikeSecretsPlugin;
